import { useLocation, useNavigate } from "react-router-dom";
import { TrendingUp, Tag, Briefcase, Wallet, User } from "lucide-react";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

const navItems = [
  { path: "/markets", label: "Markets", icon: TrendingUp },
  { path: "/sell", label: "Sell", icon: Tag },
  { path: "/portfolio", label: "Portfolio", icon: Briefcase },
  { path: "/payments", label: "Payments", icon: Wallet },
  { path: "/profile", label: "Profile", icon: User },
];

export function MobileBottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const [user, setUser] = useState<any>(null);

  useEffect(() => {
    supabase.auth.getUser().then(({ data }) => setUser(data.user));
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
    });
    return () => subscription.unsubscribe();
  }, []);

  // Don't show on auth page or if not logged in
  if (!user || location.pathname === "/auth" || location.pathname === "/reset-password") {
    return null;
  }

  // Don't show on admin/partner/brand nested layouts
  if (
    location.pathname.startsWith("/vault-partner/") ||
    location.pathname.startsWith("/brand/") ||
    location.pathname.startsWith("/admin/")
  ) {
    return null;
  }

  const isActive = (path: string) => {
    if (path === "/profile") return location.pathname === "/profile" || location.pathname === "/settings";
    return location.pathname === path;
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-lg border-t border-border md:hidden safe-area-bottom">
      <div className="flex items-center justify-around h-16 px-2">
        {navItems.map((item) => {
          const active = isActive(item.path);
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className="relative flex flex-col items-center justify-center gap-0.5 flex-1 h-full transition-colors"
            >
              {active && (
                <motion.div
                  layoutId="bottomNavIndicator"
                  className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-primary rounded-full"
                  transition={{ type: "spring", stiffness: 500, damping: 35 }}
                />
              )}
              <item.icon
                className={`h-5 w-5 transition-colors ${
                  active ? "text-primary" : "text-muted-foreground"
                }`}
              />
              <span
                className={`text-[10px] font-medium transition-colors ${
                  active ? "text-primary" : "text-muted-foreground"
                }`}
              >
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
